import React from "react";
import "./Expriy.less";
import Lottie from "react-lottie";
import * as data from "./lottie/data.json";

class Expriy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data,
    };
  }

  componentDidMount() {
    document.title = "链接已失效";
  }

  closeWindow() {
    window.WeixinJSBridge.call("closeWindow");
  }
  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: data,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
    return (
      <div className="expriy">
        <div className="content">
          <div className="DefaultIcon">
            <Lottie options={defaultOptions} height={100} width={100} />
            <p>{this.props.title}</p>
          </div>
          <div className="title">链接已失效</div>
        </div>
        <div className="close-btn" onClick={this.closeWindow}>
          关闭
        </div>
      </div>
    );
  }
}

export default Expriy;
